/**
 * Picks a stable Tailwind class string for a contact avatar bubble so
 * the same person always renders the same colour across the app
 * (inbox rows, threads, mentions). The seed should be something that
 * doesn't change for that contact — contact id is best, with name or
 * phone as fallbacks.
 */

const AVATAR_PALETTE: string[] = [
  'bg-rose-100 text-rose-700 ring-rose-200 dark:bg-rose-500/15 dark:text-rose-300 dark:ring-rose-500/30',
  'bg-orange-100 text-orange-700 ring-orange-200 dark:bg-orange-500/15 dark:text-orange-300 dark:ring-orange-500/30',
  'bg-amber-100 text-amber-700 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-300 dark:ring-amber-500/30',
  'bg-emerald-100 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-300 dark:ring-emerald-500/30',
  'bg-sky-100 text-sky-700 ring-sky-200 dark:bg-sky-500/15 dark:text-sky-300 dark:ring-sky-500/30',
  'bg-indigo-100 text-indigo-700 ring-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-300 dark:ring-indigo-500/30',
  'bg-violet-100 text-violet-700 ring-violet-200 dark:bg-violet-500/15 dark:text-violet-300 dark:ring-violet-500/30',
  'bg-pink-100 text-pink-700 ring-pink-200 dark:bg-pink-500/15 dark:text-pink-300 dark:ring-pink-500/30',
  'bg-lime-100 text-lime-700 ring-lime-200 dark:bg-lime-500/15 dark:text-lime-300 dark:ring-lime-500/30',
];

export function avatarTint(seed: string | null | undefined): string {
  const s = seed && seed.length ? seed : '?';
  let hash = 0;
  for (let i = 0; i < s.length; i++) {
    hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  }
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
}

/**
 * Picks an initial character for an avatar bubble — uppercase first
 * char of the display name, '#' when only a phone is known, '?' otherwise.
 */
export function avatarInitial(
  displayName: string | null | undefined,
  phone?: string | null,
): string {
  if (displayName && displayName.trim().length) {
    return displayName.trim().charAt(0).toUpperCase();
  }
  return phone ? '#' : '?';
}
